export enum MediaBreakPoints { // styles/_variables.scss
  TABLET = 930,
  MOBILE_LARGE = 720,
  MOBILE_MEDIUM = 560,
  MOBILE_SMALL = 460,
}

export enum FormNames {
  REGAPPLY = "apply-reg",
  CODEREG = "code-reg",
  PHONE = "input-phone",
  CODE = "input-code",
  PASSWORD = "input-password",
  PASSWORD_APPLY = "password-apply",
  MESSAGE = "confirm-message",
  ERROR_PHONE = "error-phone-not-found",
  ERROR_CODE = "error-bad-code",
  ERROR = "error",
}

export enum WindowNames {
  CODE = "TESTcode",
  AUTH = "auth",
  AUTH_SUCCESS = "authSuccess",
  AUTH_ERROR = "authError",
  FORGOT_PASS = "forgotPass",
  REGISTRATION = "register",
  REGISTRATION_SUCCESS = "regSuccess",
  ERROR = "error",
  ERROR_CODE = "error-bad-code",
}

export const appController = {
  DISABLE_NEXT_MONTH_DATES: false,
  AFK_TIMER_MINUTES: 15,
};

// @ts-ignore - require используется для импорта изображений в webpack
declare function require(path: string): string;

export const hallImages = {
  // @ts-ignore
  1: require("../assets/img/hallsPhoto/hall1-main.jpg"),
  // @ts-ignore
  2: require("../assets/img/hallsPhoto/hall2-main.jpg"),
  // @ts-ignore
  3: require("../assets/img/hallsPhoto/hall3-main.jpg"),
  // @ts-ignore
  4: require("../assets/img/hallsPhoto/hall4-main.jpg"),
  // @ts-ignore
  5: require("../assets/img/hallsPhoto/hall5-main.jpg"),
  // @ts-ignore
  6: require("../assets/img/hallsPhoto/hall6-main.jpg"),
  // @ts-ignore
  7: require("../assets/img/hallsPhoto/hall7-main.jpg"),
  // @ts-ignore
  8: require("../assets/img/hallsPhoto/hall8-main.jpg"),
  // @ts-ignore
  9: require("../assets/img/hallsPhoto/hall9-main.jpg"),
  // @ts-ignore
  10: require("../assets/img/hallsPhoto/hall10-main.jpg"),
  // @ts-ignore
  11: require("../assets/img/hallsPhoto/hall11-main.jpg"),
  // @ts-ignore
  12: require("../assets/img/hallsPhoto/hall12-main.jpg"),
  // @ts-ignore
  13: require("../assets/img/hallsPhoto/hall13-main.jpg"),
  // @ts-ignore
  14: require("../assets/img/hallsPhoto/hall14-main.jpg"),
  // @ts-ignore
  15: require("../assets/img/hallsPhoto/hall15-main.jpg"),
};
